
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class TitleButtons extends Vue {
  @Prop({ default: "" })
  activeClass!: string;

  @Prop({ default: "" })
  icon!: string;

  @Prop({ default: "" })
  text!: string;

  @Prop({ default: "white" })
  color!: string;

  @Prop({ default: false })
  disabled!: boolean;

  /** Shows the spinner while the action it fires is still running. */
  @Prop({ default: false })
  loading!: boolean;

  @Prop(String)
  action!: string;

  onClick() {
    this.$emit(this.action);
    this.$emit("btnClick", this.action);
  }
}
